import { Injectable } from '@angular/core';
import {
    ISectorServicesConfig
} from "libraries/component/booking-information/components/sectors/components/shared/interfaces/ISectorServicesConfig";
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { Observable } from "rxjs";
import { IPostReservationConfiguration } from "libraries/interfaces/i-post-reservation-configuration";

@Injectable()
export class BookingDomainService {

    constructor(
        private readonly configurationResourceService: ConfigurationResourceService,
    ) {
    }

    public getSectorsConfiguration(): Observable<ISectorServicesConfig>{
        return this.configurationResourceService.get<ISectorServicesConfig>(
            ['wui', 'app_sasha', 'config', 'booking-page', 'sector-services.json'],
            {
                air: {},
                stay: {}
            }
        )
    }
    public getPostReservationConfiguration(): Observable<IPostReservationConfiguration>{
        return this.configurationResourceService.get<IPostReservationConfiguration>(
            ['wui', 'app_iaqobohotel', 'config', 'post-reservation', 'post-reservation.json'],
            {},
        )
    }
}
